import { Component, inject, input, output } from '@angular/core';
import { TrackLinkDirective, TrackProductService } from '@analytics/events';
import type { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { ProductDuration } from '@innogy/server/get-offer/interfaces';
import { mapOfferToCommerce } from '@innogy/become-a-customer/shared';
import { AnalyticsActionTypes } from '@analytics/models';
import { DatalayerService } from '@analytics/datalayer';
import { ToolTrackingUtils } from '@analytics/utils';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CrntButton } from '@essent/current-web-angular';

import { getSpecificOfferValueFromOffer } from '../utils';

@Component({
  selector: 'wl-variable-offer-card',
  templateUrl: './variable-offer-card.component.html',
  styleUrls: ['./variable-offer-card.component.essent.scss'],
  standalone: true,
  imports: [
    TrackLinkDirective,
    CSCaptureDirective,
    AutomationIdDirective,
    CrntButton,
  ],
})
export class VariableOfferCardComponent {
  private readonly trackProductService = inject(TrackProductService);
  private readonly dataLayer = inject(DatalayerService);
  private readonly toolTrackingUtils = inject(ToolTrackingUtils);

  readonly title = input<string>();
  readonly description = input<string>();
  readonly buttonTitle = input<string>();
  readonly explanationButtonTitle = input<string>();
  readonly isBestChoice = input(false);

  showExplanation = output<ReturnType<typeof getSpecificOfferValueFromOffer>>();
  selectOffer = output();

  readonly variableOffer: Offer = {
    contractType: 'variable',
    offerId: '',
    campaignId: '',
    duration: ProductDuration.ONE,
    commodities: [],
    offerOverviews: [],
    vatIncluded: false,
    expectedYearlyAmount: 0,
    expectedMonthlyAmount: 0,
    beforeDiscountExpectedYearlyAmount: 0,
    beforeDiscountExpectedMonthlyAmount: 0,
    usps: [],
    disclaimerContent: '',
    isDynamicProduct: false,
    productTitle: this.title() ?? 'Variabel',
    productSubtitle: '',
    isHighlighted: false,
    dynamicPricingTitle: '',
  };

  async selectOfferAndTrack() {
    this.selectOffer.emit();

    const commerceObject = {
      ...mapOfferToCommerce(this.variableOffer),
      isBesteKeuze: this.isBestChoice(),
    };
    this.trackProductService.trackSelection(commerceObject);

    this.dataLayer.pushEvent({
      event: AnalyticsActionTypes.STEP,
      info: await this.toolTrackingUtils.getToolMetadata({
        toolName: 'Keuzehulp',
        step: 0,
        stepName: 'Variable modal open',
      }),
    });
  }
}
